












import { Vue, Component } from "vue-property-decorator";

// Enums/Data
import { ClientTemplateCodes } from "@/data/enums/clientTemplates";

@Component({
  components: {
    ClientTemplateProvider: () =>
      import(
        `@/components/app/global/clientTemplates/clientTemplateProvider.vue`
      )
  }
})
export default class CheckoutTrustMessaging extends Vue {
  // Computed

  public get basketSummaryFooterProps() {
    return {
      code: ClientTemplateCodes.BASKET_SUMMARY_FOOTER,
      objectId: this.$store.state.brand.id
    };
  }
}
